import "@fontsource/lexend";
import "@fontsource/lexend/100.css";
import "@fontsource/lexend/200.css";
import "@fontsource/lexend/300.css";
import "@fontsource/lexend/400.css";
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import "@fontsource/lexend/800.css";
import "@fontsource/lexend/900.css";
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './service-page.css';

export default function ServicePage() {
    const [searchParams] = useSearchParams();
    const hideNav = searchParams.get('hideNav') === 'true';

    useEffect(() => {
        document.title = "Marlo - Terms of Service";
    }, []);

    return (
        <div className="service-page">
            {!hideNav && <Header />}
            <div className="service-content">
            <h1>Marlo Terms of Service</h1>

            Thank you for choosing Marlo. Your relationship with Marlo is governed by the following Terms of Service ("Terms"). These terms apply to all users of our Marlo products and services, which include our iOS and Android apps, as well as our website (collectively referred to as our "Products"). By using Marlo, you signify your agreement to these Terms and acknowledge that you have reviewed our Privacy Policy. Moreover, you affirm that you have read and agreed to our Marlo Community Guidelines.
            <br /><br /> 
            For residents of the United States, these Terms include an arbitration clause. For more information, kindly refer to Section 13 of the Terms.
            <br />
            <h2>Terms of Service</h2>
            <ol>
                <li>
                    <b>Acceptance of Terms</b> <br /><br />
                    By using Marlo, you agree to comply with these Terms of Service ("Terms") and acknowledge your understanding of our Privacy Policy. Your consent to these Terms further implies that you have read and accepted our Marlo Community Guidelines. If any part of these Terms is not agreeable to you, kindly refrain from using Marlo.
                </li>
                <br />
                <li>
                    <b>Eligibility</b> <br /><br />
                    Marlo is not accessible to anyone under 18. If you're below 18, you should only use Marlo with the consent of a parent or guardian. Ensure your guardian has reviewed these Terms with you. Your use of Marlo implies that you comply with any laws or regulations pertinent to your jurisdiction.
                </li>
                <br />
                <li>
                    <b>Account Registration</b> <br /><br />
                    Certain Marlo features might necessitate account creation. It's imperative that you maintain the confidentiality of your account details. Any activity under your account is your responsibility. Ensure the details you provide during registration are accurate and current.
                </li>
                <br />
                <li>
                    <b>User Conduct</b> <br /><br />
                    You pledge to use Marlo in compliance with all relevant laws. You are accountable for your actions on Marlo and any resultant consequences. Abide by our Marlo Community Guidelines and steer clear of prohibited activities.
                </li>
                <br />
                <li>
                    <b>Intellectual Property Rights</b> <br /><br />
                    Marlo holds the rights to all intellectual property related to our Products. You're prohibited from copying, altering, or exploiting Marlo without our explicit written permission.
                </li>
                <br />
                <li>
                    <b>User Content</b> <br /><br />
                    You alone are responsible for the content you share on Marlo. You grant Marlo a global, non-exclusive, royalty-free license to use and adapt your content to enhance and promote Marlo.
                </li>
                <br />
                <li>
                    <b>Third-Party Links and Services</b> <br /><br />
                    Marlo may have links to external sites or services. We are not accountable for the content or practices of these third parties. Use them at your discretion.
                </li>
                <br />
                <li>
                    <b>Termination</b> <br /><br />
                    Marlo reserves the right to terminate or suspend your access without prior notice or liability.
                </li>
                <br />
                <li>
                    <b>Disclaimers and Limitations of Liability</b> <br /><br />
                    Marlo is provided without any guarantees, either implied or direct. We renounce all warranties, including merchantability and infringement. Marlo isn't liable for any indirect consequences arising from your use.
                </li>
                <br />
                <li>
                    <b>Indemnification</b> <br /><br />
                    You pledge to protect Marlo against any claims or losses stemming from your use of our Products or any violation of these Terms.
                </li>
                <br />
                <li>
                    <b>Governing Law and Jurisdiction</b> <br /><br />
                    The laws of the jurisdiction where Marlo operates, irrespective of conflict laws, govern these Terms.
                </li>
                <br />
                <li>
                    <b>Changes to These Terms</b> <br /><br />
                    Marlo can alter these Terms. Continued use after such changes indicates your acceptance.
                </li>
                <br />
                <li>
                    <b>Arbitration (For U.S. Residents)</b> <br /><br />
                    U.S. residents agree to resolve disputes via arbitration, renouncing any court claims or jury trials.
                </li>
                <br />
                <li> 
                    <b>Contact Information</b> <br /><br />
                    For queries about these Terms, please reach out to us: Hello@himarlo.com
                </li>
            </ol>
            </div>
            {!hideNav && <Footer />}
        </div>
    )
}